type FilterParams = {
  searchTerm?: string;
  createdAtFrom?: string;
  createdAtTo?: string;
  emailVerified?: boolean;
  anonymous?: boolean;
};

export const userAdminQueryKeys = {
  all: ["users"] as const,
  list: (params: FilterParams & { page?: number; size?: number; sort?: string[] }) =>
    ["users", "list", params] as const,
  stats: (params: FilterParams) => ["users", "stats", params] as const,
  detail: (id: string) => ["users", "detail", id] as const,
} as const;
